import { API, VM } from '..';

export const mapSettingsFromApiToVm = (settings: API.Settings): VM.Settings => ({
  userPreferences: mapUserPreferencesFromApiToVm(settings.userPreferences),
  appSettings: mapAppSettingsFromApiToVm(settings.appSettings),
});

const mapUserPreferencesFromApiToVm = (
  userPreferences: API.UserPreferences
): VM.UserPreferences => ({
  language: userPreferences.language,
});

const mapAppSettingsFromApiToVm = (appSettings: API.AppSettings): VM.AppSettings => ({
  allowActions: appSettings.allowActions,
  enableTrainerSignature: appSettings.enableTrainerSignature,
  enableOperatorSignature: appSettings.enableOperatorSignature,
  enableUploadEvidence: appSettings.enableUploadEvidence,
});
